import { createStyles, Theme } from '@material-ui/core/styles';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {},
    row: {
      marginBottom: spacing(6),

      '&> *:first-child': {
        marginRight: spacing(4),
      },

      '&:last-of-type': {
        marginBottom: 0,
      },
    },
    rowElement: {
      width: '50%',
      // If there's only one element in the row, padding aligns it with rows that have two
      '&:only-child': {
        paddingRight: spacing(2),
      },
    },
    fullRowElement: {
      width: '100%',
    },
    label: {
      display: 'inline-block',
      marginBottom: spacing(2),
      fontWeight: 500,
      lineHeight: '16px',
      color: '#1D2433', //TODO replace after creating new palette
    },
    countrySelect: {
      width: '100%',
    },
  });
